<script setup>
import HelloWorld from './components/HelloWorld.vue'
import TheWelcome from './components/TheWelcome.vue'
</script>

<template>
  <Toast />
  <router-view></router-view>
</template>

<style>
#app {
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
